import React, { useState, useContext, useEffect, useCallback, useMemo } from "react";
// import { UserContext } from "../../context/UserContext.js";
import { useToast } from "../../context/ToastContext.js";
import Pagination from "../pagination/Pagination.js";
import { FaCoins, FaCartPlus, FaCopy, FaPlus, FaRandom, FaCalendarAlt, FaFilter } from "react-icons/fa";
import { FaTurkishLiraSign } from "react-icons/fa6";
import {
  useCreateReferralCodeMutation,
  useGetReferralOrdersQuery,
} from "../../services/userApi.js";

import "./CouponComponent.css";
import Loader from "../Loader.js";

const CouponComponent = () => {
  // const { createCoupon, createReferralCode, getCoupons, coupons, getReferralOrders, referralOrders, totalCommission } = useContext(UserContext);
  const { data: referralOrdersData, isLoading: isLoadingReferralOrders, refetch: refetchReferralOrders } = useGetReferralOrdersQuery();
  const [createReferralCode, { isLoading: isCreatingReferralCodeMutation }] = useCreateReferralCodeMutation();
  // const [createCoupon, { isLoading: isCreatingCoupon }] = useCreateCouponMutation();

  const [showCouponModal, setShowCouponModal] = useState(false);
  const [showReferralModal, setShowReferralModal] = useState(false);
  const [couponAmount, setCouponAmount] = useState('');
  const [customReferralCode, setCustomReferralCode] = useState('');
  const [generatedReferralCode, setGeneratedReferralCode] = useState('');
  const { showToast } = useToast();
  const [isLoading, setIsLoading] = useState(false);
  // const [isCreatingReferralCode, setIsCreatingReferralCode] = useState(false);
  const [copySuccess, setCopySuccess] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const ordersPerPage = 10;

  // Ay filtresi için state
  const [selectedMonth, setSelectedMonth] = useState('');
  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
  const [filteredOrders, setFilteredOrders] = useState([]);
  const [filterApplied, setFilterApplied] = useState(false);
  const [dataReady, setDataReady] = useState(false);

  // referralOrders ve totalCommission'ı RTK'dan gelen veriden al
  // useMemo ile hesaplandığında performans artabilir ve her render'da tekrar hesaplanmaz
  const referralOrders = useMemo(() => referralOrdersData?.orders || [], [referralOrdersData]);
  const totalCommission = useMemo(() => referralOrdersData?.commission || 0, [referralOrdersData]);
  const lastPaymentDateFormatted = useMemo(() => referralOrdersData?.lastPaymentDateFormatted || "Hiç ödeme yapılmadı", [referralOrdersData]);
  const salesAfterLastPayment = useMemo(() => referralOrdersData?.salesAfterLastPayment || 0, [referralOrdersData]);

  // Yükleme durumunu takip et
  useEffect(() => {
    if (isLoadingReferralOrders) {
      setIsLoading(true);
      setDataReady(false);
    } else {
      setIsLoading(false);
      if (referralOrdersData && referralOrdersData.orders) {
        // Veri hazır olduğunda
        setDataReady(true);

        // Eğer filtre uygulanmadıysa tüm siparişleri göster (en yeniden en eskiye sıralı)
        if (!filterApplied) {
          const sortedOrders = [...referralOrders].sort((a, b) => {
            // order_date_timestamp'e göre azalan sırada sırala (en yeni en üstte)
            return (b.order_date_timestamp || 0) - (a.order_date_timestamp || 0);
          });
          setFilteredOrders(sortedOrders);
        }
      }
    }
  }, [isLoadingReferralOrders, referralOrdersData, referralOrders, filterApplied]);

  // Ay ve yıla göre filtreleme
  const filterOrdersByMonth = useCallback(() => {
    setFilterApplied(true);

    if (!dataReady || !referralOrders.length) {
      // Veri hazır değilse veya sipariş yoksa tüm siparişleri göster
      setFilteredOrders(referralOrders);
      return;
    }

    // Eğer herhangi bir sipariş timestamp değerine sahip değilse basit bir hesaplama yapalım
    // Bu kod sadece demo amaçlıdır, gerçek timestamp değeri olmadığı için
    // referans kodu kullanarak simüle edilmiş bir timestamp değeri oluşturuyoruz 
    const hasAnyTimestamp = referralOrders.some(order => order.order_date_timestamp > 0);

    if (!hasAnyTimestamp) {
      // Pseudo-timestamp oluştur - bu sadece demo amaçlıdır
      // Her referans kodundan sayısal bir değer üretiyoruz
      const filtered = referralOrders.filter(order => {
        // Referans kodundan bir sayı üret
        const refCode = order.referral_code || "";
        // Son 4 karakteri al (varsa) ve sayısal değer oluştur
        const pseudoValue = refCode.slice(-4);
        const pseudoMonth = (pseudoValue.charCodeAt(0) % 12) + 1; // 1-12 arası bir ay
        const pseudoYear = selectedYear; // Seçilen yılı kullan

        // Ay seçilmediyse sadece yıl eşleşmesine bak
        if (!selectedMonth) {
          return pseudoYear === parseInt(selectedYear);
        }
        
        // Seçilen ay ve yıl ile eşleşiyor mu kontrol et
        return pseudoMonth === parseInt(selectedMonth) && pseudoYear === parseInt(selectedYear);
      });
      // Filtrelenmiş siparişleri en yeniden en eskiye sırala
      const sortedFiltered = filtered.sort((a, b) => {
        return (b.order_date_timestamp || 0) - (a.order_date_timestamp || 0);
      });
      setFilteredOrders(sortedFiltered);
      setCurrentPage(1);
      return;
    }

    try {
      // Gerçek timestamp değeri varsa normal filtreleme yap
      const filtered = referralOrders.filter(order => {
        // Order'ın timestamp değeri yoksa filtreleme yapma
        if (!order || !order.order_date_timestamp) {
          return false;
        }

        // Timestamp'i Date nesnesine dönüştür
        const orderDate = new Date(order.order_date_timestamp * 1000);

        // Geçerli bir tarih mi kontrol et
        if (isNaN(orderDate.getTime())) {
          console.warn(`Geçersiz tarih: ${order.order_date_timestamp}`);
          return false;
        }

        const orderMonth = orderDate.getMonth() + 1; // JavaScript ayları 0-11 arası
        const orderYear = orderDate.getFullYear();

        // Ay seçilmediyse sadece yıl filtresini uygula
        if (!selectedMonth) {
          return orderYear === parseInt(selectedYear);
        }
        
        // Seçilen ay ve yıla eşleşiyor mu?
        return orderMonth === parseInt(selectedMonth) && orderYear === parseInt(selectedYear);
      });

      // Filtrelenmiş siparişleri en yeniden en eskiye sırala
      const sortedFiltered = filtered.sort((a, b) => {
        return (b.order_date_timestamp || 0) - (a.order_date_timestamp || 0);
      });
      setFilteredOrders(sortedFiltered);
      setCurrentPage(1); // Sayfa numarasını sıfırla
    } catch (error) {
      console.error("Filtreleme sırasında hata:", error);
      showToast("Filtreleme yapılırken bir hata oluştu", "error");
      // Hata durumunda tüm siparişleri göster
      setFilteredOrders(referralOrders);
    }
  }, [selectedMonth, selectedYear, referralOrders, dataReady, showToast]);

  // Filtre temizleme
  const clearFilter = useCallback(() => {
    setSelectedMonth('');
    setFilterApplied(false);
    // Tüm siparişleri en yeniden en eskiye sıralı olarak göster
    const sortedOrders = [...referralOrders].sort((a, b) => {
      return (b.order_date_timestamp || 0) - (a.order_date_timestamp || 0);
    });
    setFilteredOrders(sortedOrders);
  }, [referralOrders]);

  // Toplam satış tutarını hesapla
  const totalSalesAmount = useMemo(() => {
    return filteredOrders?.reduce((total, order) => {
      return total + order.products.reduce((orderTotal, product) => orderTotal + product.total_amount, 0);
    }, 0) || 0;
  }, [filteredOrders]);

  // Para birimi formatı için yardımcı fonksiyon
  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('tr-TR', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(amount);
  };

  const handleCouponConversion = async () => {
    // try {
    //   const result = await createCoupon(parseFloat(couponAmount)); // Bu kısım için RTK hook'u userApi.js'e eklenmeli

    //   if (result.success) {
    //     showToast(`${couponAmount}₺ değerinde kupon oluşturuldu. Kupon Kodunuz: ${result.couponCode}`, "success");
    //     setShowCouponModal(false);
    //     setCouponAmount('');
    //     // await getCoupons(); // RTK Query ile refetch edilebilir veya cache güncellenebilir
    //   } else {
    //     showToast("Kupon oluşturulurken bir hata oluştu", "error");
    //   }
    // } catch (error) {
    //   showToast(error.message || "Kupon oluşturulurken bir hata oluştu", "error");
    // }
    showToast("Kupon oluşturma özelliği RTK entegrasyonu için güncellenmeli.", "info");
  };

  const handleCreateReferralCode = async () => {
    try {
      // setIsCreatingReferralCode(true); // RTK kendi isLoading durumunu yönetir
      const result = await createReferralCode(customReferralCode || null).unwrap();

      if (result.success) {
        setGeneratedReferralCode(result.share_code);
        setShowReferralModal(true);
        showToast("Referans kodu başarıyla oluşturuldu", "success");
        setCustomReferralCode('');
        refetchReferralOrders();
      } else {
        showToast(result.message || "Referans kodu oluşturulurken bir hata oluştu", "error");
      }
    } catch (error) {
      showToast(error.data?.message || error.message || "Referans kodu oluşturulurken bir hata oluştu", "error");
    }
    // finally {
    //   setIsCreatingReferralCode(false);
    // }
  };

  // Metin kopyalama fonksiyonu
  const copyToClipboard = (text, label) => {
    try {
      // Yardımcı textarea elementi oluştur
      const textArea = document.createElement('textarea');
      textArea.value = text;
      // Görünmez yap
      textArea.style.position = 'fixed';
      textArea.style.left = '-999999px';
      textArea.style.top = '-999999px';
      document.body.appendChild(textArea);

      // Seç ve kopyala
      textArea.focus();
      textArea.select();

      const successful = document.execCommand('copy');
      document.body.removeChild(textArea);

      if (successful) {
        setCopySuccess(`${label || 'Metin'} kopyalandı!`);
        setTimeout(() => setCopySuccess(''), 2000);
        if (label) {
          showToast(`${label} kopyalandı`, "success");
        }
      } else {
        // execCommand başarısız olursa modern API'yi dene
        navigator.clipboard.writeText(text)
          .then(() => {
            setCopySuccess(`${label || 'Metin'} kopyalandı!`);
            setTimeout(() => setCopySuccess(''), 2000);
            if (label) {
              showToast(`${label} kopyalandı`, "success");
            }
          })
          .catch(err => {
            setCopySuccess('Kopyalama başarısız!');
            console.error('Kopyalama hatası:', err);
            showToast("Kopyalama işlemi başarısız oldu", "error");
          });
      }
    } catch (err) {
      setCopySuccess('Kopyalama başarısız!');
      console.error('Kopyalama hatası:', err);
      showToast("Kopyalama işlemi başarısız oldu", "error");
    }
  };

  const openReferralCodeModal = () => {
    setShowReferralModal(true);
    setGeneratedReferralCode('');
  };

  // Sayfalama hesaplamaları
  const indexOfLastOrder = currentPage * ordersPerPage;
  const indexOfFirstOrder = indexOfLastOrder - ordersPerPage;
  const currentOrders = filteredOrders ? filteredOrders.slice(indexOfFirstOrder, indexOfLastOrder) : [];
  const totalPages = filteredOrders ? Math.ceil(filteredOrders.length / ordersPerPage) : 0;

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  // Ay seçimi için options
  const months = [
    { value: "1", label: "Ocak" },
    { value: "2", label: "Şubat" },
    { value: "3", label: "Mart" },
    { value: "4", label: "Nisan" },
    { value: "5", label: "Mayıs" },
    { value: "6", label: "Haziran" },
    { value: "7", label: "Temmuz" },
    { value: "8", label: "Ağustos" },
    { value: "9", label: "Eylül" },
    { value: "10", label: "Ekim" },
    { value: "11", label: "Kasım" },
    { value: "12", label: "Aralık" }
  ];

  // Yıl seçimi için options (mevcut yıl ve 5 yıl öncesi)
  const years = [];
  const currentYear = new Date().getFullYear();
  for (let year = currentYear; year >= currentYear - 5; year--) {
    years.push(year);
  }

  if (isLoading) {
    return (
      <div className="user-loading-container">
        <div className="spinner-container">
          <Loader size={40}/>
        </div>
      </div>
    );
  }

  return (
    <div className="earnings-container">
      <div className="earnings-summary">
        <div className="row g-3 mb-4">

          <div className="col-md-4 col-6">
            <div className="summary-card">
              <div className="summary-icon">
                <FaCartPlus />
              </div>
              <div className="summary-content">
                <h4>Toplam Satış</h4>
                <p className="summary-value">{filteredOrders?.length || 0} Adet</p>
              </div>
            </div>
          </div>

          <div className="col-md-4 col-6">
            <div className="summary-card">
              <div className="summary-icon">
                <FaTurkishLiraSign />
              </div>
              <div className="summary-content">
                <h4>Toplam Satış Tutarı</h4>
                <p className="summary-value">₺{formatCurrency(totalSalesAmount)}</p>
              </div>
            </div>
          </div>

          <div className="col-md-4 col-6">
            <div className="summary-card">
              <div className="summary-icon">
                <FaCoins />
              </div>
              <div className="summary-content">
                <h4>Son Ödeme Sonrası Satış</h4>
                <p className="summary-value">₺{formatCurrency(salesAfterLastPayment)}</p>
              </div>
            </div>
          </div>

          <div className="col-md-4 col-6">
            <div className="summary-card">
              <div className="summary-icon">
                <FaCoins />
              </div>
              <div className="summary-content">
                <h4>Toplam Kazanç</h4>
                <p className="summary-value">
                  ₺{formatCurrency(totalCommission)}
                </p>
              </div>
            </div>
          </div>

          <div className="col-md-4 col-12">
            <div className="summary-card">
              <div className="summary-icon">
                <FaCalendarAlt />
              </div>
              <div className="summary-content">
                <h4>Son ödeme Tarihi</h4>
                <p className="summary-value">{lastPaymentDateFormatted}</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {showCouponModal && (
        <div className="modal-overlay">
          <div className="modal-wrapper">
            <div className="modal-content">
              <h3 className="modal-title">Kazancınızı Kupona Dönüştürün</h3>
              <div className="modal-body">
                <div className="form-group mb-3">
                  <label className="form-label">Dönüştürülecek Miktar</label>
                  <input
                    type="number"
                    className="form-input"
                    value={couponAmount}
                    onChange={(e) => setCouponAmount(e.target.value)}
                  />
                </div>
                <p className="form-hint">
                  * Test amaçlı limit kaldırıldı.
                </p>
              </div>
              <div className="modal-footer">
                <button
                  className="btn-secondary"
                  onClick={() => setShowCouponModal(false)}
                >
                  İptal
                </button>
                <button
                  className="btn-primary"
                  onClick={handleCouponConversion}
                >
                  Kupona Dönüştür
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {showReferralModal && (
        <div className="modal-overlay">
          <div className="modal-wrapper">
            <div className="modal-content bg-white">
              <h3 className="modal-title">Referans Kodu Oluştur</h3>

              {!generatedReferralCode ? (
                <div className="modal-body">
                  <div className="form-group m-0">
                    <label className="form-label">Kendi Referans Kodunuzu Yazın</label>
                    <div className="input-with-button">
                      <input
                        type="text"
                        className="reference-input"
                        placeholder="Referans Kodu Giriniz"
                        value={customReferralCode}
                        onChange={(e) => setCustomReferralCode(e.target.value.toUpperCase())}
                        maxLength={8}
                      />
                      <button
                        className="btn-primary"
                        onClick={handleCreateReferralCode}
                        disabled={isCreatingReferralCodeMutation || !customReferralCode.trim()}
                      >
                        {isCreatingReferralCodeMutation ? 'Oluşturuluyor...' : 'Oluştur'}
                      </button>
                    </div>
                  </div>

                  <div className="modal-footer">
                    <button
                      className="btn-secondary"
                      onClick={() => {
                        setCustomReferralCode('');
                        handleCreateReferralCode();
                      }}
                      disabled={isCreatingReferralCodeMutation}
                    >
                      <FaRandom className="btn-icon" /> Rastgele Oluştur
                    </button>
                    <button
                      className="btn-light"
                      onClick={() => setShowReferralModal(false)}
                    >
                      İptal
                    </button>
                  </div>
                </div>
              ) : (
                <div className="modal-body">
                  <div className="code-display">
                    <strong>{generatedReferralCode}</strong>
                  </div>
                  <p className="form-hint text-center">
                    Bu kodu arkadaşlarınıza gönderebilirsiniz. Arkadaşlarınız bu kodu kullanarak alışveriş yaptığında komisyon kazanırsınız.
                  </p>
                  <div className="modal-footer">
                    <button
                      className="btn-primary"
                      onClick={() => copyToClipboard(generatedReferralCode, "Referans kodu")}
                    >
                      <FaCopy className="btn-icon" /> Kopyala
                    </button>
                    <button
                      className="btn-light"
                      onClick={() => setShowReferralModal(false)}
                    >
                      Kapat
                    </button>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      )}

      {/* Kupon Listesi */}
      {/* <div className="coupons-list">
        <h4>Kuponlarım</h4>
        <div className="coupons-container">
          {isLoading ? (
            <p>Kuponlar yükleniyor...</p>
          ) : (
            <>
              <div className="coupons-grid">
                {coupons && coupons.map((coupon) => (
                  <div key={coupon.id} className="coupon-card">
                    <div className="coupon-header">
                      <span className="coupon-code">{coupon.code}</span>
                      <span className={`coupon-status ${coupon.status.toLowerCase()}`}>
                        {coupon.status === 'ACTIVE' ? 'Aktif' :
                          coupon.status === 'USED' ? 'Kullanıldı' : 'İptal Edildi'}
                      </span>
                    </div>
                    <div className="coupon-details">
                      <div className="coupon-amount">
                        <span className="coupon-label">Tutar:</span>
                        <span className="coupon-value">₺{coupon.amount}</span>
                      </div>
                      <div className="coupon-date">
                        <span className="coupon-label">Oluşturma Tarihi:</span>
                        <span className="coupon-value">{new Date(coupon.created_at).toLocaleDateString('tr-TR')}</span>
                      </div>
                    </div>
                  </div>
                ))}
              </div>

              <div className="coupons-table">
                <table>
                  <thead>
                    <tr>
                      <th>Kupon Kodu</th>
                      <th>Tutar</th>
                      <th>Oluşturma Tarihi</th>
                      <th>Durum</th>
                    </tr>
                  </thead>
                  <tbody>
                    {coupons && coupons.map((coupon) => (
                      <tr key={coupon.id}>
                        <td>{coupon.code}</td>
                        <td>₺{coupon.amount}</td>
                        <td>{new Date(coupon.created_at).toLocaleDateString('tr-TR')}</td>
                        <td>
                          <span className={`coupon-status ${coupon.status.toLowerCase()}`}>
                            {coupon.status === 'ACTIVE' ? 'Aktif' :
                              coupon.status === 'USED' ? 'Kullanıldı' : 'İptal Edildi'}
                          </span>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              {(!coupons || coupons.length === 0) && (
                <div className="no-coupons">
                  Henüz oluşturulmuş kupon bulunmamaktadır.
                </div>
              )}
            </>
          )}
        </div>
      </div> */}

      <div className="referral-orders">
        <div className="d-flex flex-column gap-3">
          <div className="d-flex flex-md-row flex-column align-items-center justify-content-between">
            <h4 className="text-center">Referans Kodumla Yapılan Siparişler</h4>
            <button
              className="btn-create"
              onClick={openReferralCodeModal}
              disabled={isCreatingReferralCodeMutation}
            >
              <FaPlus className="btn-icon" /> Referans Kodu Oluştur
            </button>
          </div>
          <div className="filter-container mx-auto">
            <div className="filter-controls">
              <span>Filtrele:</span>
              <div className="filter-group">
                <label>Ay:</label>
                <select
                  value={selectedMonth}
                  onChange={(e) => setSelectedMonth(e.target.value)}
                  className="filter-select"
                >
                  <option value="">Tüm Aylar</option>
                  {months.map(month => (
                    <option key={month.value} value={month.value}>{month.label}</option>
                  ))}
                </select>
              </div>
              <div className="filter-group">
                <label>Yıl:</label>
                <select
                  value={selectedYear}
                  onChange={(e) => setSelectedYear(e.target.value)}
                  className="filter-select"
                >
                  {years.map(year => (
                    <option key={year} value={year}>{year}</option>
                  ))}
                </select>
              </div>
              <button
                className="btn-secondary"
                onClick={filterOrdersByMonth}
              >
                <FaFilter /> Filtrele
              </button>
              {selectedMonth && (
                <button
                  className="btn-light"
                  onClick={clearFilter}
                >
                  Filtreyi Temizle
                </button>
              )}
            </div>
          </div>
        </div>

        <div className="orders-container">
          {isLoadingReferralOrders ? (
            <div className="loading-container">
              <div className="spinner"></div>
              <p>Siparişler yükleniyor...</p>
            </div>
          ) : filteredOrders && filteredOrders.length > 0 ? (
            <div className="orders-grid">
              {currentOrders.map((order) => (
                <div key={order.id} className="order-card">
                  <div className="order-header">
                    <div className="d-flex flex-column">
                      <span className="order-code">Referans Kodu: <strong>{order.referral_code}</strong></span>
                      <span className="order-total">
                        Toplam: ₺<strong>{order.products.reduce((total, product) => total + product.total_amount, 0).toFixed(2)}</strong>
                      </span>
                    </div>
                    <div>
                      <span className="order-date">
                        {new Date(order.order_date_timestamp * 1000).toLocaleDateString('tr-TR', {
                          day: '2-digit',
                          month: '2-digit',
                          year: 'numeric'
                        })}
                      </span>
                    </div>
                  </div>
                  <div className="order-products">
                    {order.products.map((product, index) => (
                      <div key={index} className="product-item">
                        {product.product_image && (
                          <img
                            src={product.product_image.startsWith('https://') ? product.product_image : `https://panel.bikuyum.com/upload/${product.product_image}`}
                            alt={product.product_title}
                            className="product-image"
                          />
                        )}
                        <div className="product-info">
                          <p className="product-title">{product.product_title}</p>
                          <div className="product-details">
                            <span className="product-price">
                              Tutar: ₺{product.total_amount.toFixed(2)}
                            </span>
                            <span className="product-earning">
                              Kazanç: ₺{(product.total_amount * 0.01).toFixed(2)}
                            </span>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div className="no-data-message">
              Henüz referans kodunuzla yapılmış sipariş bulunmamaktadır.
            </div>
          )}

          {totalPages > 1 && (
            <div className="pagination-container">
              <Pagination
                currentPage={currentPage}
                totalPages={totalPages}
                onPageChange={setCurrentPage}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default CouponComponent;